// extracted by mini-css-extract-plugin
export default {"tag":"BAcTagListWithBrowse-module_tag_ac5b1e09","tagSelected":"BAcTagListWithBrowse-module_tagSelected_f1e74211","tagAble":"BAcTagListWithBrowse-module_tagAble_d891fc4d"};